/** Chemin centralisé du logo Selah.
 *  LOGO_URL   = wordmark "SELAH" avec croix (site web, auth, onboarding)
 *  APP_LOGO   = symbole seul (icône app, favicon) */
export const LOGO_URL = '/assets/logo/logo-wordmark.svg'
export const APP_LOGO = '/assets/logo/logo-app.svg'
